var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.inline ? 'slideForm-inline' : 'slideForm']},[_c('div',{staticClass:"slideForm-main"},[_vm._t("default")],2),_c('div',{staticClass:"slideForm-footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }